(function () {
  function injectOnce(selector, className, html, insert) {
    if (!html || document.querySelector('.' + className)) return;

    const target = document.querySelector(selector);
    if (!target) return;

    const el = document.createElement('div');
    el.className = className;
    el.innerHTML = html;
    insert(target, el);
  }

  function isB2B() {
    return window.TitanSliderRules?.isB2B;
  }

  function formatMoney(cents) {
    const format = window.theme?.settings?.moneyWithCurrencyFormat;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && format) {
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getTradeSavings(cart) {
    let saved = 0;
    let retail = 0;

    cart.items.forEach(function (item) {
      const compareAt = item.compare_at_price || 0;
      if (compareAt > item.price) {
        retail += compareAt * item.quantity;
        saved += (compareAt - item.price) * item.quantity;
      }
    });

    return {
      saved: saved,
      percent: retail ? Math.round((saved / retail) * 100) : 0
    };
  }

  function injectTrade(cart) {
    const cartRoot = document.querySelector('.amp-cart');
    if (!cartRoot) return;

    cartRoot.querySelectorAll(
      '.titan-amp-cart-trade-badge, .titan-amp-cart-trade-savings, .titan-amp-cart-trade-applied'
    ).forEach(function (el) { el.remove(); });

    if (!isB2B() || !cart?.items?.length) return;

    const tier = window.TitanAmpCart?.tradeTier || 'Trade Silver';
    const savings = getTradeSavings(cart);
    const header = cartRoot.querySelector('.amp-cart__header');

    if (header) {
      const badge = document.createElement('span');
      badge.className = 'titan-amp-cart-trade-badge';
      badge.textContent = tier;
      header.appendChild(badge);

      if (savings.saved) {
        const banner = document.createElement('div');
        banner.className = 'titan-amp-cart-trade-savings';
        banner.textContent = "You're saving " + formatMoney(savings.saved)
          + ' (' + savings.percent + '%) as a ' + tier + ' member';
        header.after(banner);
      }
    }

    if (savings.saved) {
      const footer = cartRoot.querySelector('.amp-cart__footer');
      const subtotal = footer && (
        footer.querySelector('.amp-cart__footer-subtotal')
        || footer.querySelector('[class*="subtotal"]')
      );

      if (footer) {
        const note = document.createElement('p');
        note.className = 'titan-amp-cart-trade-applied';
        note.textContent = 'Trade price applied';

        if (subtotal) subtotal.after(note);
        else footer.prepend(note);
      }
    }
  }

  function injectTrustBadges() {
    injectOnce(
      '.amp-cart__upsell',
      'titan-amp-cart-trust',
      window.TitanAmpCart?.trustHtml,
      function (target, el) { target.after(el); }
    );
  }

  function injectSocialProof() {
    const html = window.TitanAmpCart?.socialProofHtml;
    if (!html || document.querySelector('.titan-amp-cart-social-proof')) return;

    const target = document.querySelector('.amp-cart__upsell')
      || document.querySelector('.amp-cart__cart-lines');
    if (!target) return;

    const el = document.createElement('div');
    el.className = 'titan-amp-cart-social-proof';
    el.innerHTML = html;
    target.before(el);
  }

  function injectPayments() {
    const html = window.TitanAmpCart?.paymentMethodsHtml;
    const footer = document.querySelector('.amp-cart__footer');
    if (!footer) return;

    let el = footer.querySelector('.titan-amp-cart-payments');

    if (!html) {
      if (el) el.remove();
      return;
    }

    if (!el) {
      el = document.createElement('div');
      el.className = 'titan-amp-cart-payments';
      const checkout = footer.querySelector('.amp-cart__footer-checkout-button');
      if (checkout) checkout.after(el);
      else footer.appendChild(el);
    }

    el.innerHTML = html;
  }

  function injectDispatch(cart) {
    const footer = document.querySelector('.amp-cart__footer');
    if (!footer || !window.titanResolveAmpCartDispatch) return;

    let slot = footer.querySelector('.titan-amp-cart-dispatch-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'titan-amp-cart-dispatch-slot';
      const checkout = footer.querySelector('.amp-cart__footer-checkout-button');
      if (checkout) checkout.before(slot);
      else footer.appendChild(slot);
    }

    window.titanResolveAmpCartDispatch(cart).then(function (html) {
      slot.innerHTML = html;
    });
  }

  window.titanInjectAmpCartMessaging = function (cart) {
    injectTrade(cart);
    injectTrustBadges();
    injectSocialProof();
    injectPayments();
    if (cart) injectDispatch(cart);
  };
})();
